import { render, staticRenderFns } from "./WorkTransfer.vue?vue&type=template&id=57674d3e&scoped=true"
import script from "./WorkTransfer.vue?vue&type=script&lang=js"
export * from "./WorkTransfer.vue?vue&type=script&lang=js"
import style0 from "./WorkTransfer.vue?vue&type=style&index=0&id=57674d3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57674d3e",
  null
  
)

export default component.exports